import { render, staticRenderFns } from "./TranslationUploadBatchCreate.vue?vue&type=template&id=12f5f65c"
import script from "./TranslationUploadBatchCreate.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports